import { model as sessionModel } from '$/session'
import { createEvent, sample } from 'effector'
import { loadBanners, resetBanners } from './banners'
import { dirtyRows, loadRows, resetRows } from './rows'

export * from './lib'
export * from './rows'
export * from './view'

export const init = createEvent<{ query: URLSearchParams }>()
export const left = createEvent()

//
// banners
//

sample({
  clock: init,
  target: loadBanners,
})

sample({
  clock: sessionModel.$session,
  target: resetBanners,
})

//
// rows
//

sample({
  clock: init,
  target: loadRows,
})

sample({
  clock: left,
  target: dirtyRows,
})

sample({
  clock: sessionModel.$session,
  target: resetRows,
})
